export default {
  GetQuotationReportParameter(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromActionDate: input.reportCriteria.transactionSearchCriteria.fromAcceptedDate,
      toActionDate: input.reportCriteria.transactionSearchCriteria.toAcceptedDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      isShowPurchaseOrderAsset: input.reportCriteria.isShowPurchaseOrderAsset,
    };

    return reportParameter;
  },
  GetInvoiceReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
    };

    return reportParameter;
  },
  GetReceiptReportParameterModel(input) {
    let reportParameter = {
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      isShowAllPayment: input.reportCriteria.isShowAllPayment,
      isShowElectronicStatus: input.reportCriteria.isShowElectronicStatus,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
    };

    return reportParameter;
  },
  GetTaxInvoiceReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      isShowElectronicStatus: input.reportCriteria.isShowElectronicStatus,
      transactionTableView: input.reportCriteria.transactionTableView,
      isRevenueDepartmentFormat: input.reportCriteria.isRevenueDepartmentFormat,
      filterETaxInvoiceType: input.reportCriteria.filterETaxInvoiceType,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
    };

    return reportParameter;
  },
  GetCreditNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      isShowAllPayment: input.reportCriteria.isShowAllReceivePayment,
      isShowElectronicStatus: input.reportCriteria.isShowElectronicStatus,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
    };

    return reportParameter;
  },
  GetDebitNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
    };

    return reportParameter;
  },
  GetBillingNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowDeleted: input.reportCriteria.isDisplayVoidDocument,
      isShowAllItem: input.reportCriteria.isShowAllProduct,
      tableSorting: input.reportCriteria.tableSorting,
      isShowAllPayment: input.reportCriteria.isShowAllPayment,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
    };

    return reportParameter;
  },
  GetJournalReportParameterModel(input) {
    let reportParameter = {
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.journalTable.tableStatus,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isShowDeleted: input.isShowDeleted,
      searchText: input.journalTable.searchText,
      journalTableType: input.journalTable.journalTableType,
      tableSorting: input.journalTable.tableSorting,
      journalTableView: input.journalTable.journalTableView,
      contactId: input.journalTable.searchAdvance.contactId,
      searchNumber: input.journalTable.searchAdvance.searchTextTransactionNumber,
      searchReference: input.journalTable.searchAdvance.searchTextReference,
      searchDescription: input.journalTable.searchAdvance.searchTextTransactionDescription,
      journalAccountDescription: input.journalTable.searchAdvance.searchTextTransactionItemDescription,
      tagIdList: input.journalTable.searchAdvance.tagIdList,
      isAllTagSearch: input.journalTable.searchAdvance.isAllTagSearch,
      createdUserId: input.journalTable.searchAdvance.createdUserId,
      approvedUserId: input.journalTable.searchAdvance.approvedUserId,
      reviewedUserId: input.journalTable.searchAdvance.reviewedUserId,
      accountId: input.journalTable.searchAdvance.accountId,
      journalAccountReferenceId: input.journalTable.searchAdvance.accountReferenceId,
      journalAccountReferenceTypeId: input.journalTable.searchAdvance.accountReferenceType,
      allocationIdList: input.journalTable.searchAdvance.allocationIdList,
      allocationItemIdList: input.journalTable.searchAdvance.allocationItemIdList,
      isNotHaveAllocation: input.journalTable.searchAdvance.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.journalTable.searchAdvance.isNotHaveAnyAllocation,
      fromNetAmount: input.journalTable.searchAdvance.fromNetAmount,
      toNetAmount: input.journalTable.searchAdvance.toNetAmount,
    };
    return reportParameter;
  },
};
